export default "__VITE_ASSET__CKwmBDOR__"